import { configureStore } from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import apiStateReducer from './ApiStateStore'
import creditApplicationReducer from './CreditApplicationStore/creditApplication-store'
import appReducer from './AppStore/app-store'

export function InitializeStore() {
  return configureStore({
    reducer: {
      api: apiStateReducer,
      app: appReducer,
      creditApplication: creditApplicationReducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }),
  })
}

export const store = InitializeStore()

export type TRootState = ReturnType<typeof store.getState>
export type TAppDispatch = typeof store.dispatch

export const useAppDispatch = () => useDispatch<TAppDispatch>()
export const useAppSelector: TypedUseSelectorHook<TRootState> = useSelector
